import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/siteInfo";

const columns = [
  {
    title: "内容导航",
    links: [
      { label: "剧集列表", to: "/episodes" },
      { label: "角色分析", to: "/characters" },
      { label: "影视资讯", to: "/news" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "联系我们", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              {siteInfo.tagline}。提供逐集剧情解析、角色深度分析与最新影视资讯，帮助观众更好地理解剧情进展与人物关系。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-mail-line text-base"></i>
              </span>
              {siteInfo.contactEmail}
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">
                {col.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name} 影视内容站 · 本站为内容演示站点</p>
          <p>剧集信息与角色资料均为虚构示例，不涉及播放、下载与支付功能</p>
        </div>
      </div>
    </footer>
  );
}